// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_descriptors.js
// module id = 27
// module chunks = 48 49 50 51